export const IMAGES = {
  portrait: "/images/dr-lokesh-naik.jpg",
  sculpture:
    "https://images.unsplash.com/photo-1548811579-017cf2a4268b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtYXJibGUlMjBzY3VscHR1cmUlMjByZXN0b3JhdGlvbnxlbnwwfHx8fDE3ODY4MDg2NjZ8MA&ixlib=rb-4.1.0&q=85&w=1200",
  running: "/images/recovery-figure.jpg",
  hospital:
    "https://images.unsplash.com/photo-1719934398679-d764c1410770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwaG9zcGl0YWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODY4MDg2Nzh8MA&ixlib=rb-4.1.0&q=85&w=1200",
  xray:
    "https://images.unsplash.com/photo-1516069677018-378515003435?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHx4LXJheSUyMGJvbmUlMjBqb2ludCUyMGFic3RyYWN0fGVufDB8fHx8MTc4NjgwODY3OHww&ixlib=rb-4.1.0&q=85&w=1200",
  caseElbow: "/images/case-elbow-fixation.jpg",
  caseHumerus: "/images/case-humerus-plating.jpg",
};

export const DOCTOR = {
  name: "Dr. Lokesh Naik G",
  title: "Orthopaedic Trauma Surgery Specialist",
  role: "Senior Orthopaedic Trauma, Reconstruction & Joint Replacement Consultant",
  hospital: "Sir H. N. Reliance Foundation Hospital & Research Centre",
  hospitalArea: "Girgaon, Mumbai",
  experience: "16+",
  phoneDisplay: "+91 84337 46205",
  phoneHref: "tel:+918433746205",
  email: "drortholokesh@outlook.com",
  emailHref: "mailto:drortholokesh@outlook.com",
  emailHospital: "Lokesh.Naik@rfhospital.org",
  emailHospitalHref: "mailto:Lokesh.Naik@rfhospital.org",
  appointmentLines: [
    { label: "Appointment Desk", number: "022-3547 5757", href: "tel:+912235475757" },
    { label: "Appointment Desk", number: "022-3547 5000", href: "tel:+912235475000" },
    { label: "Toll Free", number: "1800 890 1111", href: "tel:18008901111" },
  ],
  linkedin: "https://www.linkedin.com/in/dr-lokesh-naik-g-224575131/",
  instagram: "https://www.instagram.com/g.lokeshnaik/",
  opdHours: [
    { day: "Monday – Friday", time: "11:00 AM – 7:00 PM" },
    { day: "Saturday", time: "11:00 AM – 3:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  qualifications: [
    "M.B.B.S. — JJMMC, Davanagere",
    "Diploma in Orthopaedics — KIMS, Hubli",
    "D.N.B. (Orthopaedic Surgery) — Nanavati Hospital, Mumbai",
    "Fellowship in Trauma — Mumbai",
    "Fellowship in Primary Arthroplasty — Mumbai",
    "Fellowship in Revision Arthroplasty — Seoul, South Korea",
  ],
};

export const EXPERTISE = [
  {
    title: "Complex Fractures & Dislocations",
    description:
      "High-energy trauma demands decisive, precise intervention. Surgical stabilisation of complex fractures and joint dislocations, restoring anatomy and function.",
    tags: ["ORIF", "Trauma Care", "Emergency Surgery"],
  },
  {
    title: "Peri-Articular Fractures",
    description:
      "Fractures around joints — knee, hip, shoulder, ankle — require meticulous reconstruction to preserve movement and prevent early arthritis.",
    tags: ["Joint Preservation", "Reconstruction"],
  },
  {
    title: "Pelvic & Acetabular Fractures",
    description:
      "Among the most demanding injuries in orthopaedics. Advanced fixation techniques for pelvic ring and hip socket fractures, honed through dedicated fellowship training.",
    tags: ["Pelvic Fixation", "Acetabulum"],
  },
  {
    title: "Osteoporotic & Pathological Fractures",
    description:
      "Fragile bone needs a gentle but definitive approach — fixation strategies designed for compromised bone quality in elderly and medically complex patients.",
    tags: ["Fragility Fractures", "Geriatric Care"],
  },
  {
    title: "Malunion & Nonunion of Fractures",
    description:
      "When fractures heal wrongly — or not at all. Corrective osteotomies, bone grafting and revision fixation to give failed fractures a second chance.",
    tags: ["Revision Fixation", "Bone Grafting"],
  },
  {
    title: "Bone & Joint Infections",
    description:
      "Co-investigator in the AO 'INFINITY' study — the world's largest multicentre study on infection in fracture fixation. Evidence-led management of osteomyelitis and infected implants.",
    tags: ["Osteomyelitis", "INFINITY Study"],
  },
  {
    title: "Soft Tissue Injuries",
    description:
      "Tendon, ligament and soft tissue damage accompanying fractures — repaired and rehabilitated as one integrated plan, not an afterthought.",
    tags: ["Ligament Repair", "Tendon Reconstruction"],
  },
  {
    title: "Post-Traumatic Deformity Correction",
    description:
      "Limb lengthening, bow-leg correction and realignment of deformities that follow injury — restoring the mechanical axis and the confidence to walk tall.",
    tags: ["Limb Lengthening", "Osteotomy"],
  },
];

export const PROCEDURES = [
  "Open Reduction & Internal Fixation (ORIF)",
  "Total Hip Replacement",
  "Total Knee Replacement",
  "Revision & Redo Orthopaedic Surgeries",
  "Limb Lengthening & Deformity Correction",
  "Ankle Fusion Surgery",
  "Bow Legs Correction",
  "Fracture Fixation — Simple to Complex",
];

export const TIMELINE = [
  {
    period: "Foundation",
    role: "M.B.B.S., then Diploma in Orthopaedics",
    place: "Karnataka Institute of Medical Sciences, Hubli",
  },
  {
    period: "5 Years",
    role: "Lecturer / Consultant in Orthopaedic Surgery",
    place: "S.S.I.M.S. & R.C., Davanagere, Karnataka",
  },
  {
    period: "Residency",
    role: "D.N.B. (Orthopaedic Surgery)",
    place: "Dr. Balabhai Nanavati Hospital, Mumbai",
  },
  {
    period: "2 Years",
    role: "Clinical Associate, Orthopaedics",
    place: "Dr. Balabhai Nanavati Hospital, Mumbai",
  },
  {
    period: "2013 — 2015",
    role: "Co-Investigator, 'INFINITY' Study",
    place: "AO Foundation, Davos, Switzerland — the world's largest multicentre study on infection in fracture fixation",
  },
  {
    period: "Fellowships",
    role: "Trauma & Primary Arthroplasty (Mumbai), Revision Arthroplasty (Seoul)",
    place: "Mumbai & Seoul, South Korea",
  },
  {
    period: "2016 – Present",
    role: "Senior Orthopaedic Trauma, Reconstruction & Joint Replacement Consultant",
    place: "Sir H. N. Reliance Foundation Hospital & Research Centre, Mumbai",
  },
];

export const EDITORIAL_ROLES = [
  {
    role: "Associate Editor",
    journal: "Orthopaedics and Sports Medicine: Open Access Journal (OSMOA), USA",
  },
  {
    role: "National Editorial Board Member",
    journal: "Indian Journal of Orthopaedics Surgery",
  },
  {
    role: "Reviewer",
    journal: "Indian Journal of Orthopaedics",
  },
];

export const MARQUEE_WORDS = [
  "Precision",
  "Restoration",
  "Mobility",
  "Trust",
  "Evidence-Based Care",
  "Recovery",
];

export const CASES = [
  {
    src: "/images/case-elbow-fixation.jpg",
    alt: "X-ray of a complex elbow fracture fixed with plates and screws",
    caption: "Elbow fracture — fixed",
    testId: "case-image-elbow",
  },
  {
    src: "/images/case-humerus-plating.jpg",
    alt: "X-ray of a humerus shaft fracture fixed with a locking plate",
    caption: "Humerus fracture — plated",
    testId: "case-image-humerus",
  },
  {
    src: "/images/case-wrist-plate.jpg",
    alt: "X-ray of a wrist (distal radius) fracture fixed with a volar locking plate",
    caption: "Wrist fracture — volar plate",
    testId: "case-image-wrist",
  },
  {
    src: "/images/case-wrist-ulna.jpg",
    alt: "X-ray of wrist and ulna fractures fixed with a plate and screw",
    caption: "Wrist & ulna — fixed",
    testId: "case-image-wrist-ulna",
  },
  {
    src: "/images/case-knee-plateau.jpg",
    alt: "X-ray of a knee (tibial plateau) fracture fixed with a buttress plate",
    caption: "Knee plateau — fixed",
    testId: "case-image-knee",
  },
  {
    src: "/images/case-tibia-plates.jpg",
    alt: "X-ray of tibia and fibula fractures fixed with plates and screws",
    caption: "Tibia & fibula — plated",
    testId: "case-image-tibia",
  },
  {
    src: "/images/case-calcaneus.jpg",
    alt: "X-ray of a heel bone (calcaneus) fracture fixed with a plate",
    caption: "Heel bone — fixed",
    testId: "case-image-calcaneus",
  },
  {
    src: "/images/case-shoulder.jpg",
    alt: "X-ray of a shoulder (proximal humerus) fracture fixed with a locking plate",
    caption: "Shoulder fracture — plated",
    testId: "case-image-shoulder",
  },
  {
    src: "/images/case-foot-ap.jpg",
    alt: "X-ray AP view of midfoot fusion fixed with a plate",
    caption: "Foot fusion — front view",
    testId: "case-image-foot-ap",
  },
  {
    src: "/images/case-foot-oblique.jpg",
    alt: "X-ray oblique view of midfoot fusion fixed with a plate",
    caption: "Foot fusion — side view",
    testId: "case-image-foot-oblique",
  },
  {
    src: "/images/case-arm-ap.jpg",
    alt: "X-ray front view of an arm (humerus) fracture fixed with a long plate",
    caption: "Arm fracture — front view",
    testId: "case-image-arm-ap",
  },
  {
    src: "/images/case-arm-lat.jpg",
    alt: "X-ray side view of an arm (humerus) fracture fixed with a long plate",
    caption: "Arm fracture — side view",
    testId: "case-image-arm-lat",
  },
  {
    src: "/images/case-shoulder-locking.jpg",
    alt: "C-arm view of a shoulder fracture fixed with a locking plate and screws",
    caption: "Shoulder — locking plate",
    testId: "case-image-shoulder-locking",
  },
  {
    src: "/images/case-arm-carm.jpg",
    alt: "C-arm close-up of arm plate fixation during surgery",
    caption: "Arm fixation — in surgery",
    testId: "case-image-arm-carm",
  },
  {
    src: "/images/case-plate-intraop.jpg",
    alt: "C-arm intra-operative view of fracture plate fixation",
    caption: "Fixation — intra-op view",
    testId: "case-image-intraop",
  },
];

export const REVIEWS = [
  { name: "Swasthi Shetty", text: "An excellent orthopaedic doctor who is kind, caring, and highly skilled. My father received outstanding treatment and I truly appreciate the doctor's dedication. Highly recommended!" },
  { name: "Nikita Sanghvi", text: "The doctor is very helpful, kind, knowledgeable and patient. He is a good listener and understands every word told to him properly. I have a great experience going to this doctor and I suggest people to visit him for consultation." },
  { name: "Dr. Akshita Jain", text: "Knowledgeable, gentle, soft spoken and very helpful also — which is the need of the hour." },
  { name: "Raj Gandhi", text: "Dr. Naik is somebody who is at the top of his game and yet the most humble doctor we have come across. My father's treatment has been carried out by him with utter patience and grace — it was a complicated case!" },
  { name: "Neeta Shashi", text: "Dr Lokesh is one of the fantastic orthopedic surgeons I have ever met. I underwent an implant surgery for an ankle fracture and he was the surgeon for me. The journey as a patient with him was extremely smooth." },
  { name: "Anita Randive", text: "I got my right wrist operated by Dr. Lokesh Naik. When it comes to surgeries, I admit feeling anxious — but having a doctor of his caliber provides patients with the reassurance and confidence needed." },
  { name: "Aryan Jain", text: "I got my elbow operated by doctor Lokesh Naik around 3 months ago and the outcome has been amazing." },
  { name: "Dipali Gala", text: "My mother-in-law had a fall and both her shoulders were damaged. When we approached Doctor Naik, he explained everything very calmly — what has happened and what needs to be done." },
  { name: "Prashant Dudugu", text: "One of the best people we met during my dad's surgery — one must blindly depend on the work that Dr. Lokesh Naik does. Thank you very much sir for your kind gesture towards us." },
  { name: "Meena Parikh", text: "Dr. Lokesh is a very friendly doctor, always satisfies queries. Before surgery I was explained the full procedure. Very happy with him and his team — will give more than five stars if allowed." },
  { name: "Seshu S", text: "Very experienced and highly skilled doctor who gives continuous support to patients with the best care." },
  { name: "Mohammad Tazeem Lodhia", text: "He is the best doctor one can have. Very polite and helpful — he treats patients as if they are his own family member and is very concerned about patient health." },
  { name: "Mohini Panhalkar", text: "Dr. Lokesh sir is very professional. Takes time to explain things and resolve problems. Highly grateful for his experience and wide range of knowledge." },
  { name: "Mangesh Purohit", text: "Doc Lokesh Naik G is a very good doc, his nature is very good and very friendly. He solved my problem very well — may God bless you." },
  { name: "Dr. Jayesh Bhanushali", text: "Excellent surgeon and an amazing human being." },
  { name: "Sneha Sanghvi", text: "I am satisfied with the treatment — recovery is very good. Thank you for such a good treatment." },
  { name: "Shayna Padvekar", text: "Really very nice experience. You are the best ortho!" },
  { name: "Manisha Dhobi", text: "Nice experience — helpful and effective treatment." },
  { name: "Nergish Postwala", text: "Excellent experience. Very caring and soft-spoken Dr. Lokesh — I am sure I will get well soon." },
  { name: "Seema Sharma Tiwari", text: "He is an excellent doctor who patiently listens to our problems." },
  { name: "Somil Gosar", text: "I felt confident and well cared for throughout the entire experience." },
  { name: "Imran Abbas Syed", text: "He is very soft spoken and down to earth." },
];
